import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useSelector, shallowEqual } from "react-redux";

import * as apiFile from "../../api/file";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { useIsMobile } from "../../useIsMobile";
import { getDatabaseNamePath } from "../../config/config";

const ImsGuide = () => {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const isMobile = useIsMobile();
  const playerRef = useRef(null);

  const [video, setVideo] = useState(null);
  const [videoError, setVideoError] = useState(false);
  //   const FALLBACK_URL = "https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";

    /*
    apiFile.download(user.authToken, value.name, securedPath)
    */

  useEffect(() => {
    // Non può funzionare perchè restituisce un file e non un video da un percorso assoluto
    // var prmise = apiFile.download(user.authToken, '_IMS VideoGuida_20251103.mp4', '/documenti/_IMS VideoGuida_20251103.mp4', false);
    if (getDatabaseNamePath() == "valderma") setVideo(toAbsoluteUrl("/media/documenti/_IMS_VideoGuida_20251103.mp4"));
    else setVideo(toAbsoluteUrl("/media/documenti/_IMS_VideoGuida_20251103.mp4"));
  }, [user.authToken]);

  return (
    <>
      <div className="ims-guide-paragraph">
        <h2>Ciao {user.firstname},</h2>
        Di seguito ti illustreremo le istruzioni di base per una corretta consultazione dei dati IMS
      </div>
      {videoError && (
        <div className="text-muted small mt-2 px-3">Sorgente video non trovata. Riproduzione del video di prova.</div>
      )}
      <div className={`ims-guide-player-wrapper`}>
        <div className={`ims-guide-player-container ${isMobile ? "mobile" : "desktop"}`}>
          <video
            ref={playerRef}
            controls
            playsInline
            webkit-playsinline="true"
            preload="metadata"
            style={{ width: "100%", height: "100%" }}
            onClick={() => playerRef.current?.play()}
          >
            <source src={video} type="video/mp4" />
            Il tuo browser non supporta il tag video.
          </video>
        </div>
      </div>
    </>
  );
};

export default ImsGuide;
